// Theme: plasma-frost
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'plasma-frost',
  name: 'PLASMA FROST',
  tagline: 'PLASMA FROST',
  description: 'Plasma gelado. Estrutura Plasma, paleta ciano frio.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0D1E30', '#152540', '#6AD4F0', '#EEF9FF'],
  familyId: 'plasma',
  variantName: 'FROST',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-plasma-frost'
  },
  colorVars: {
    '--accent': '#6AD4F0',
    '--accent-foreground': '#0D1E30',
    '--background': '#0D1E30',
    '--border': '#1A5A7A',
    '--card': '#152540',
    '--card-border-active': 'rgba(106, 212, 240, 0.58)',
    '--card-completed': '#122030',
    '--card-foreground': '#EEF9FF',
    '--card-glow': 'rgba(106, 212, 240, 0.12)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0D1E30',
    '--foreground': '#EEF9FF',
    '--hold-fill': '#6AD4F0',
    '--input': '#1A5A7A',
    '--modal-bg': '#0D1E30',
    '--modal-border': '#1A5A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.20)',
    '--muted': '#1A5A7A',
    '--muted-foreground': '#EEF9FF',
    '--nav-active': '#6AD4F0',
    '--nav-bg': '#152540',
    '--popover': '#152540',
    '--popover-foreground': '#EEF9FF',
    '--primary': '#6AD4F0',
    '--primary-foreground': '#0D1E30',
    '--ring': '#6AD4F0',
    '--secondary': '#1A5A7A',
    '--secondary-foreground': '#EEF9FF',
    '--streak': '#6AD4F0',
    '--success': '#22c55e',
    '--success-foreground': '#0D1E30',
    '--xp': '#6AD4F0',
    '--xp-bg': '#152540'
  },
  resolvedVars: {
    '--accent': '#6AD4F0',
    '--accent-foreground': '#0D1E30',
    '--accent-foreground-hsl': '211 57% 12%',
    '--accent-foreground-oklch': 'from #0D1E30 l c h',
    '--accent-hsl': '193 82% 68%',
    '--accent-oklch': 'from #6AD4F0 l c h',
    '--background': '#0D1E30',
    '--background-hsl': '211 57% 12%',
    '--background-oklch': 'from #0D1E30 l c h',
    '--border': '#1A5A7A',
    '--border-hsl': '200 65% 29%',
    '--border-oklch': 'from #1A5A7A l c h',
    '--border-w': '1px',
    '--card': '#152540',
    '--card-border-active': 'rgba(106, 212, 240, 0.58)',
    '--card-completed': '#122030',
    '--card-completed-hsl': '212 45% 13%',
    '--card-completed-oklch': 'from #122030 l c h',
    '--card-foreground': '#EEF9FF',
    '--card-foreground-hsl': '201 100% 97%',
    '--card-foreground-oklch': 'from #EEF9FF l c h',
    '--card-glow': 'rgba(106, 212, 240, 0.12)',
    '--card-hsl': '218 51% 17%',
    '--card-oklch': 'from #152540 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0D1E30',
    '--destructive-foreground-hsl': '211 57% 12%',
    '--destructive-foreground-oklch': 'from #0D1E30 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#EEF9FF',
    '--foreground-hsl': '201 100% 97%',
    '--foreground-oklch': 'from #EEF9FF l c h',
    '--hold-fill': '#6AD4F0',
    '--hold-fill-hsl': '193 82% 68%',
    '--hold-fill-oklch': 'from #6AD4F0 l c h',
    '--input': '#1A5A7A',
    '--input-hsl': '200 65% 29%',
    '--input-oklch': 'from #1A5A7A l c h',
    '--modal-bg': '#0D1E30',
    '--modal-bg-hsl': '211 57% 12%',
    '--modal-bg-oklch': 'from #0D1E30 l c h',
    '--modal-border': '#1A5A7A',
    '--modal-border-hsl': '200 65% 29%',
    '--modal-border-oklch': 'from #1A5A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.20)',
    '--muted': '#1A5A7A',
    '--muted-foreground': '#EEF9FF',
    '--muted-foreground-hsl': '201 100% 97%',
    '--muted-foreground-oklch': 'from #EEF9FF l c h',
    '--muted-hsl': '200 65% 29%',
    '--muted-oklch': 'from #1A5A7A l c h',
    '--nav-active': '#6AD4F0',
    '--nav-active-hsl': '193 82% 68%',
    '--nav-active-oklch': 'from #6AD4F0 l c h',
    '--nav-bg': '#152540',
    '--nav-bg-hsl': '218 51% 17%',
    '--nav-bg-oklch': 'from #152540 l c h',
    '--popover': '#152540',
    '--popover-foreground': '#EEF9FF',
    '--popover-foreground-hsl': '201 100% 97%',
    '--popover-foreground-oklch': 'from #EEF9FF l c h',
    '--popover-hsl': '218 51% 17%',
    '--popover-oklch': 'from #152540 l c h',
    '--primary': '#6AD4F0',
    '--primary-foreground': '#0D1E30',
    '--primary-foreground-hsl': '211 57% 12%',
    '--primary-foreground-oklch': 'from #0D1E30 l c h',
    '--primary-hsl': '193 82% 68%',
    '--primary-oklch': 'from #6AD4F0 l c h',
    '--radius': '12px',
    '--ring': '#6AD4F0',
    '--ring-hsl': '193 82% 68%',
    '--ring-oklch': 'from #6AD4F0 l c h',
    '--secondary': '#1A5A7A',
    '--secondary-foreground': '#EEF9FF',
    '--secondary-foreground-hsl': '201 100% 97%',
    '--secondary-foreground-oklch': 'from #EEF9FF l c h',
    '--secondary-hsl': '200 65% 29%',
    '--secondary-oklch': 'from #1A5A7A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#6AD4F0',
    '--streak-hsl': '193 82% 68%',
    '--streak-oklch': 'from #6AD4F0 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0D1E30',
    '--success-foreground-hsl': '211 57% 12%',
    '--success-foreground-oklch': 'from #0D1E30 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(193 82% 68% / 0.15)',
    '--xp': '#6AD4F0',
    '--xp-bg': '#152540',
    '--xp-bg-hsl': '218 51% 17%',
    '--xp-bg-oklch': 'from #152540 l c h',
    '--xp-hsl': '193 82% 68%',
    '--xp-oklch': 'from #6AD4F0 l c h'
  }
}
